import { useLanguage } from '../i18n/LanguageProvider'

// Door open/close explainer video (Phase 76 / VIDEO-01).
//
// The asset was delivered as a YouTube Short (portrait 9:16), so we embed the
// player rather than self-host an mp4. To swap the clip, change DOOR_VIDEO_ID
// to the new YouTube video id. Set it to null to fall back to the placeholder.
// ponytail: single const is the whole "config"; no CMS/env plumbing for one clip.
export const DOOR_VIDEO_ID: string | null = 'PHvesjixCdk'

export default function DoorAccessVideo() {
  const { t } = useLanguage()
  return (
    <div
      className="rounded-[8px] overflow-hidden border border-border bg-surface max-w-[360px]"
      data-testid="door-access-video"
    >
      {DOOR_VIDEO_ID ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${DOOR_VIDEO_ID}`}
          title={t('access.video.title')}
          className="w-full aspect-[9/16] bg-black"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          data-testid="door-access-video-player"
        />
      ) : (
        <div
          className="w-full aspect-[9/16] flex flex-col items-center justify-center gap-2 text-text-muted"
          data-testid="door-access-video-placeholder"
        >
          <span aria-hidden="true" className="text-3xl text-accent">
            ▶
          </span>
          <span className="text-sm">{t('access.video.placeholder')}</span>
        </div>
      )}
    </div>
  )
}
